/**
 * Barra de progreso de 9px con relleno en gradiente. La usan la comparativa de propiedades y
 * el ranking de rentabilidad; la anchura llega ya normalizada desde la API.
 */
import { cssPercent } from '../lib/format';
import styles from './ProgressBar.module.css';

interface ProgressBarProps {
  /** Porcentaje 0–100 ya calculado en el servidor. */
  percent: number;
  /** Etiqueta accesible: sin ella la barra es puramente decorativa. */
  label?: string;
  className?: string;
}

export function ProgressBar({ percent, label, className }: ProgressBarProps) {
  return (
    <div
      className={[styles.track, className].filter(Boolean).join(' ')}
      role={label ? 'meter' : undefined}
      aria-label={label}
      aria-valuenow={label ? Math.round(percent) : undefined}
      aria-valuemin={label ? 0 : undefined}
      aria-valuemax={label ? 100 : undefined}
    >
      <div className={styles.fill} style={{ width: cssPercent(percent) }} />
    </div>
  );
}
